import type { ReactNode } from "react";

import { observer } from "mobx-react-lite";
import { useEffect } from "react";

import type { PatientMetrics } from "./daily-monitoring-metrics";
import type { DailyMonitoringModel } from "./daily-monitoring-model";

/**
 * Renders one lazily-loaded metric value for a patient. Triggers the model's
 * (idempotent) metrics fetch on mount, then shows a placeholder while loading,
 * a dash on error, or the rendered value once loaded.
 */
export const MetricCell = observer(function MetricCell({
  model,
  patientId,
  testId,
  render,
}: {
  model: DailyMonitoringModel;
  patientId: number;
  testId: string;
  render: (metrics: PatientMetrics) => ReactNode;
}) {
  useEffect(() => {
    void model.ensureMetrics(patientId);
  }, [model, patientId]);

  const entry = model.metrics.get(patientId);
  if (!entry || entry.status === "loading") {
    return <span className="text-muted-foreground">…</span>;
  }
  if (entry.status === "error") {
    return <span className="text-muted-foreground">–</span>;
  }
  return <span data-testid={testId}>{render(entry.data)}</span>;
});
